import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/transnetBW/tng-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-8db055f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-8" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Maststandort Checkliste", -1))
const _hoisted_4 = { class: "text-xs" }
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "100"
  })
], -1))
const _hoisted_7 = { class: "text-xs" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"grid gap-0 grid-cols-3 p-0 m-0\" data-v-8db055f4><div data-v-8db055f4><hr class=\"trenner\" data-v-8db055f4></div><div class=\"mt-0.5\" data-v-8db055f4><hr class=\"trenner\" data-v-8db055f4></div><div data-v-8db055f4><hr class=\"trenner\" data-v-8db055f4></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageCounter = _resolveComponent("PageCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.useIdentifierFrageFinder(
            _ctx.ba,
            'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.vorhaben'
          )?.getCurrentInput()), 1),
      _createElementVNode("div", _hoisted_5, " Mast: " + _toDisplayString(_ctx.useIdentifierFrageFinder(
            _ctx.ba,
            'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.anlage'
          )?.getCurrentInput()) + " / " + _toDisplayString(_ctx.useIdentifierFrageFinder(
            _ctx.ba,
            'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.vonmastnummer'
          )?.getCurrentInput()), 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_PageCounter)
      ])
    ]),
    _hoisted_8
  ]))
}